import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import Select, { components } from "react-select";

import { I18nContext } from "../../store/context/i18nContext";
import { DialogContext } from "../../store/context/DialogContext";
import AutoFillService from "./AutoFillService";

const CityCountrySelect = ({ asLabel, style, onChange, value, noLabel }) => {
    const [cities, setCities] = useState([]);
    const { showError } = useContext(DialogContext);
    const { t } = useContext(I18nContext);
    const [selectedCity, setSelectedCity] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const selectRef = useRef(null); 

    const updateCities = useCallback(() => {
        setCities(
            toJS(AutoFillService?.cities)?.map((city) => ({
                ...city,
                value: city?.name,
                label: (
                    <div>
                        {city?.name},
                        <span style={{ color: "#707070", fontSize: "11px" }}>
                            {" " + city?.state},
                            {" " + city?.country}
                        </span>
                    </div>
                ),
            }))
        );
    }, []);

    useEffect(() => {
        if (AutoFillService.cities.length === 0) {
            AutoFillService.fetch().then(updateCities).catch(error => showError("Error", error));
        }
    }, [updateCities, showError]);

    useEffect(() => {
        if (value && cities.length) {
            const city = cities.find(c => c.name === value.city && c.state === value.state && c.country === value.country);
            if (city) setSelectedCity({...city, city : city?.name});
        }
    }, [value, cities]);

    useEffect(() => {
        updateCities();
    }, [AutoFillService.cities, updateCities]);

    const noOptionsMessage = useCallback(() => {
        return inputValue.trim() ? t("City not found") : t("Start typing to search for a city...");
    }, [t, inputValue]);

    const onInputChange = useCallback((inputValue, { action }) => {
        if (action === 'input-change') {
            setInputValue(inputValue);
        }
    }, []);

    return (
        <>
            {asLabel ? (
                <div>{selectedCity?.label ?? <div style={{ color: "grey" }}>{t("No record Found")}</div>}</div>
            ) : (
                <Select
                    ref={selectRef}
                    className="cityCountrySelect"
                    isDisabled={asLabel || cities.length === 0}
                    components={{ Input: components.Input, DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                    autoComplete="new-password"
                    options={cities}
                    styles={{ style }}
                    value={selectedCity}
                    noLabel={noLabel}
                    placeholder={t("Select City")}
                    onChange={v => {
                        if (v?.name !== value?.city || v?.state !== value?.state || v?.country !== value?.country) {
                            onChange(v);
                        }
                    }}
                    menuPlacement="auto"
                    noOptionsMessage={noOptionsMessage}
                    onInputChange={onInputChange}
                />
            )}
        </>
    );
};

export default observer(CityCountrySelect);
